module.exports = __webpack_public_path__ + "german.35ef1984.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/countries/german.png
// module id = 124
// module chunks = 0